import { render, staticRenderFns } from "./ProductNatures.vue?vue&type=template&id=e6928618&"
import script from "./ProductNatures.vue?vue&type=script&lang=js&"
export * from "./ProductNatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports